import React from "react";

const Key = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="72"
    height="72"
    viewBox="0 0 72 72"
    fill="none"
    {...props}
  >
    <path
      d="M62.9998 6L56.9998 12M34.1698 34.83L46.4998 22.5M46.4998 22.5L55.4998 31.5L65.9998 21L56.9998 12M46.4998 22.5L56.9998 12M34.1698 34.83C35.7189 36.3584 36.9503 38.1781 37.7931 40.1844C38.636 42.1906 39.0736 44.3438 39.0809 46.5199C39.0882 48.696 38.665 50.852 37.8356 52.8639C37.0062 54.8758 35.787 56.7037 34.2483 58.2424C32.7095 59.7812 30.8816 61.0003 28.8698 61.8297C26.8579 62.6591 24.7018 63.0824 22.5257 63.0751C20.3496 63.0678 18.1965 62.6301 16.1902 61.7873C14.184 60.9444 12.3642 59.713 10.8358 58.164C7.83024 55.0521 6.16713 50.8841 6.20473 46.5579C6.24232 42.2316 7.97761 38.0932 11.0368 35.034C14.0961 31.9748 18.2345 30.2395 22.5607 30.2019C26.887 30.1643 31.0549 31.8274 34.1668 34.833L34.1698 34.83Z"
      stroke="currentColor"
      strokeWidth="3.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Key;
